import React, { Component, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LeftMenu from "./LeftMenu.jsx";
import styles from "../css/main.css";
import classNames from "classnames/bind";
import { withRouter } from "react-router-dom";
import { observer, inject } from "mobx-react";
import { isMobile } from "react-device-detect";

let classnames = classNames.bind(styles);

let timer = null

const LoggedAdmin = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      {props.role === 'manager' ? (
        <span style={{ color: '#fff', marginRight: '20px', fontSize: '1rem' }}>
          {props.availableOrgs[0]?.name || ''}
        </span>
      ) : (
        <Select
          value={props.orgId || ""}
          onChange={props.handleChangeOrg}
          variant="standard"
          disableUnderline
          sx={{
            color: "#fff",
            "& .MuiSvgIcon-root": { color: "white" },
            "& .MuiSelect-select": { paddingBottom: 0 },
            marginRight: "20px",
          }}
        >
          {props.role === "admin" && props.availableOrgs.map((org) => (
            <MenuItem key={org.id} value={org.id.toString()}>{org.name}</MenuItem>
          ))}
          {props.role === "superadmin" && Object.values(props.allOrgs).map((org) => (
            <MenuItem key={org.id} value={org.id.toString()}>{org.name}</MenuItem>
          ))}
        </Select>
      )}

      <span className="baseWellCome">
        {props.user ? `Welcome, ${props.user.name}!` : ""}
      </span>

      <IconButton style={{ color: "white" }} onClick={(e) => setAnchorEl(e.currentTarget)}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <MenuItem onClick={() => { setAnchorEl(null); props.goTo("/changepassword"); }}>
          Change password
        </MenuItem>
        <MenuItem onClick={() => { setAnchorEl(null); props.signOut(); }}>
          Sign out
        </MenuItem>
      </Menu>
    </div>
  );
};

class Layout extends Component {

  maxTime = 30 * 60 * 1000

  constructor(props) {
    super(props);

    this.state = {
    };

    this.props.Auth.init().then(() => {
      const last_action_time = parseInt(localStorage.getItem('last_action_time'))
      if (!this.props.Auth.isLoggedIn || (Date.now() - last_action_time > this.maxTime)) {
        this.props.Auth.logout()
        if (this.props.history.location.hash !== '#/login') {
          this.props.history.push("/login");
        }
      } else {
        this.props.history.push(this.props.history.location)
      }
    }).catch(() => {
      this.props.Auth.logout()
      this.props.history.push("/login")
    })
  }

  goTo = path => this.props.history.push(path)

  signOut = async () => {
    await this.props.Auth.logout()
    this.props.Auth.setMenuVisible(false)
    this.props.history.push("/login");
  }

  handleToggle = () => {
    this.props.Auth.setMenuVisible(!this.props.Auth.menuVisible)
  };

  componentDidMount() {
    this.props.Auth.setMenuVisible(this.props.Auth.isLoggedIn)
    window.addEventListener('click', this.saveLastAction);
    window.addEventListener('keypress', this.saveLastAction);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      if (isMobile) {
        this.props.Auth.setMenuVisible(false)
      } else {
        this.props.Auth.setMenuVisible(this.props.Auth.isLoggedIn)
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.saveLastAction);
    window.removeEventListener('keypress', this.saveLastAction);
  }

  saveLastAction = () => {
    localStorage.setItem('last_action_time', Date.now().toString())
    clearTimeout(timer)
    timer = setTimeout(() => {
      this.props.Auth.logout()
      this.props.history.push("/login")
    }, this.maxTime)
  }

  handleChangeOrg = async (event) => {
    const value = event.target.value;
    localStorage.setItem("orgId", value);
    this.props.Auth.setOrgId(value)
    await this.props.Auth.getOrgName()

    this.props.Auth.child_id = null
    // this.props.history.push(this.props.history.location)
    setTimeout(this.props.history.push("/children"), 1000);
  };

  render() {
    switch (this.props.Auth.role) {
      case "admin":
      case "superadmin":
      default:
        return (
          <div>
            <AppBar id="app-bar" className="app-bar" position="fixed">
              <Toolbar sx={{ justifyContent: "space-between" }}>
                <IconButton edge="start" color="inherit" onClick={this.handleToggle}>
                  <MenuIcon />
                </IconButton>
                <Typography
                  variant="h6"
                  component="h2"
                  className="app-title"
                  sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}
                >
                  {this.props.Auth.orgName || "Steps to Success"}
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                {this.props.Auth.isLoggedIn && (
                  <LoggedAdmin
                    role={this.props.Auth.role}
                    user={this.props.Auth.profile}
                    orgId={this.props.Auth.orgId}
                    allOrgs={this.props.Auth.allOrgs}
                    availableOrgs={this.props.Auth.availableOrgs}
                    handleChangeOrg={this.handleChangeOrg}
                    goTo={this.goTo}
                    signOut={this.signOut}
                  />
                )}
              </Toolbar>
            </AppBar>
            <Drawer
              id="app-menu"
              className="no-print"
              anchor="left"
              variant="persistent"
              open={this.props.Auth.menuVisible}
              slotProps={{ paper: { sx: { width: 210, backgroundColor: "#1976D2", overflowX: "hidden" } } }}
            >
              <AppBar position="static" elevation={0}>
                <Toolbar>
                  <IconButton edge="start" color="inherit" onClick={this.handleToggle}>
                    <MenuIcon />
                  </IconButton>
                  <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "1.25rem" }}>Menu</Typography>
                </Toolbar>
              </AppBar>
              <LeftMenu />
            </Drawer>
            <Toolbar />
            <div className={classnames("app-content", { expanded: this.props.Auth.menuVisible })} >
              <div style={{ width: "96%", margin: "auto" }}>{this.props.children}</div>
            </div>
          </div>
        );
    }
  }
}
export default inject("Auth")(withRouter(observer(Layout)))
